export default "__VITE_ASSET__18e6317c__"